/**
 * State Farm external links that differ between test and production environments.
 *
 * Controlled by VITE_STATE_FARM_ENV. Default is 'test' so a forgetful build
 * never points users at the live www.statefarm.com domain. Set the env var to
 * 'production' for the production deploy.
 *
 * Implementation note: we intentionally use a ternary on the build-time
 * constant rather than an object lookup. Vite folds `import.meta.env.*` at
 * build time and esbuild's minifier dead-code-eliminates the unused branch,
 * so the production bundle only contains the production host string (and
 * vice versa). Object-lookup patterns leak both hosts into every bundle.
 *
 * The DEEL tracking script src in web/index.html is also toggled by the
 * stateFarmEndpointsPlugin in web/vite.config.ts — keep these two surfaces in
 * lockstep when adjusting endpoints.
 */
const SF_HOST =
  import.meta.env.VITE_STATE_FARM_ENV === 'production'
    ? 'www.statefarm.com'
    : 'www-env1.test.statefarm.com';

const SF_BASE = `https://${SF_HOST}`;

export const SF_PRIVACY = `https://www.statefarm.com/customer-care/privacy-security/privacy`;
// TODO: verify SF terms-of-use path. Standard SF marketing footer uses
// /customer-care/disclosures/terms-of-use — confirm before production cutover.
export const SF_TERMS = `https://www.statefarm.com/customer-care/disclosures/terms-of-use`;
export const SF_CA_NOTICE = `https://www.statefarm.com/customer-care/privacy-security/privacy/california-privacy-rights/notice-at-collection`;
export const SF_DO_NOT_SELL = `${SF_BASE}/customer-care/privacy-security/privacy/california-privacy-rights/do-not-sell`;
